import { apiCall, API_CONFIG } from './api';

export const reportsAPI = {
  getUserOrderReport: async (reportRange, startDate = null, endDate = null) => {
    try {
      const payload = {
        filter: reportRange
      };

      if (reportRange === 'custom') {
        payload.startDate = startDate;
        payload.endDate = endDate;
      }

      const response = await apiCall(API_CONFIG.ENDPOINTS.USER_ORDER_REPORT, {
        method: 'POST',
        body: JSON.stringify(payload)
      });

      if (response.success) {
        return { success: true, data: response.data };
      } else {
        return { success: false, error: response.msg || 'Failed to fetch report data' };
      }
    } catch (error) {
      console.error('Error fetching report data:', error);
      return { success: false, error: 'Error fetching report data: ' + error.message };
    }
  },

  getCategoryReport: async (startDate, endDate) => {
    try {
      const response = await apiCall(API_CONFIG.ENDPOINTS.CATEGORY_REPORT, {
        method: 'POST',
        body: JSON.stringify({ startDate, endDate })
      });

      if (response.success) {
        return { success: true, list: response.list || [], summary: response.data || {} };
      }

      const rawError = response.msg || response.error || 'Failed to fetch category report';
      const looksLikeHtml = typeof rawError === 'string' && rawError.trim().startsWith('<!');
      return {
        success: false,
        error: looksLikeHtml
          ? 'Failed to load report. Please check your session and try again.'
          : rawError,
      };
    } catch (error) {
      console.error('Error fetching category report:', error);
      return { success: false, error: 'Error fetching category report: ' + error.message };
    }
  },

  createExcelReport: async (userType, filter, startDate = null, endDate = null) => {
    try {
      const payload = {
        userType: userType,
        filter: filter
      };

      if (filter === 'custom') {
        payload.startDate = startDate;
        payload.endDate = endDate;
      }

      const response = await apiCall(API_CONFIG.ENDPOINTS.CREATE_EXCEL_REPORT, {
        method: 'POST',
        body: JSON.stringify(payload)
      });

      if (response.success) {
        return {
          success: true,
          data: response.data,
          fileName: response.data.fileName,
          downloadUrl: `${API_CONFIG.BASE_URL.replace('/api', '')}${response.data.URL}`
        };
      } else {
        return { success: false, error: response.msg || 'Failed to generate Excel file' };
      }
    } catch (error) {
      console.error('Error generating Excel report:', error);
      return { success: false, error: 'Failed to generate Excel file: ' + error.message };
    }
  },
};